import { useEffect, useState } from "react";
import { AddOrganizationCommand, BasicResponse, Organization, UserItem } from "../api/models/schema";
import { Box, CircularProgress, Container, Grid, Link } from "@mui/material";
import { BasicButton } from "../common/basicButton";
import { useApi } from "../hooks/useApi";
import { addOrganizationApi, getUserOrgsApi } from "../api/liveMarketingApi";
import { getCookie } from "cookies-next";
import { useNavigate } from "react-router-dom";
import { AddOrganizationForm } from "./addOrganizationForm";


export function OrganizationListPage() {

  const [userData, setUserData] = useState<UserItem | undefined>(undefined);
  const [organizations, setOrganizations] = useState<Organization[]>([]);
  const [showUpdateForm, setShowUpdateForm] = useState<boolean>(false);
  const [errorResponse, setErrorResponse] = useState<BasicResponse | undefined>(undefined);

  const getUserOrganizationsRequest = useApi(getUserOrgsApi);
  const addOrgRequest = useApi(addOrganizationApi);

  const navigate = useNavigate();

  useEffect(() => {
    const user = getCookie("userData") as string;
    if (user) {
      setUserData(JSON.parse(user));
    } else {
      navigate(`/login`);
    }
  }, []);

  //Get user's organizations

  useEffect(() => {
    if (userData) {
      fetchOrganizations();
    }
  }, [userData]);

  useEffect(() => {
    if (getUserOrganizationsRequest.data) {
      
      if (userData?.isSuperAdmin || getUserOrganizationsRequest.data.organizations.length > 1) 
      {
        setOrganizations(getUserOrganizationsRequest.data.organizations);
      }
      else{
        navigate(`/dashboard/${getUserOrganizationsRequest.data.organizations[0].orgId}`);
      }
    }
  }, [getUserOrganizationsRequest.data]);



  useEffect(() => {
    if (addOrgRequest.data) {
      refreshPage();
    }
  }, [addOrgRequest.data]);


  function onOpenFormHandler() {
    setShowUpdateForm(true);
  }

  function refreshPage() {
    setShowUpdateForm(false);
    if (userData) {
      fetchOrganizations();
    }
  }

  function fetchOrganizations() {
    getUserOrganizationsRequest.request(userData?.appUserName);
  }

  function addOrganization(addOrgCommand:AddOrganizationCommand){
    addOrgRequest.request(addOrgCommand, userData?.appUserName);
  }

  //close the add job form
  function onCloseFormHandler() {
    setShowUpdateForm(false);
  }

  function displayPageData() {
    return (
        <Container className="min-h-full gap-3">
          <h1>Welcome, {userData?.firstName}!</h1>
          {userData &&
            <Grid className="flex justify-between items-center">
              <Grid item xs={4}>
                <h4 className="flex">Your organizations</h4>
              </Grid>
              <Grid
                className="flex items-center justify-center flex-col"
                item
                xs={4}
              >
                {userData?.isSuperAdmin && (
                  <BasicButton
                    onClick={onOpenFormHandler}
                    labelText="New Organization"
                  />
                )}
              </Grid>
            </Grid>
          }

          <br/>


          {organizations.length > 0 && (
            <Grid container gap={2}>
              {organizations.map((org: Organization) => {
                return (
                  <Grid
                    key={org.orgId}
                    item
                    xs={5}
                    className="border border-solid border-gray-200 flex items-center shadow-sm rounded-2xl px-3 gap-2"
                  >
                    <div className="flex flex-col justify-between items-center w-full ">
                      <Link
                        href={`/dashboard/${org.orgId}`}
                        className="no-underline text-black w-full border-b-2 border-b-solid border-b-gray-200"
                      >
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            border: "2px solid #cecece",
                            cursor: "pointer",
                            alignItems: "center",
                            borderRadius: 5,
                            padding: 1,
                          }}
                        >

                          <Box  sx={{height:'100px'}} component='img' src={org.logoLink} alt='' />

                          <Box sx={{ diplay: "flex", flexDirection: "column" }}>
                            <h4 >{org.name}</h4>
                            <p>{org.alias}</p>
                          </Box>
                        </Box>
                      </Link>
                    </div>
                  </Grid>
                );
              })}
            </Grid>
          )}

          <AddOrganizationForm open ={showUpdateForm} 
                               onClose={onCloseFormHandler} 
                               adminUserName={userData?.appUserName ?? ''} 
                               onUpdate={addOrganization} />


        </Container>

    );
  }

  return (
    <>
      {getUserOrganizationsRequest.loading && <CircularProgress />}
      {!getUserOrganizationsRequest.loading && displayPageData()}
    </>
  );
}
